import { Component, OnInit, OnDestroy, ViewEncapsulation, Injector, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { appModuleAnimation } from '../../../../../shared/animations/routerTransition';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { PasswordComplexitySetting, ProfileServiceProxy, MyProfileOutput, ChangePasswordInput, StoreImageOnBlobDto, BlobHelperServiceProxy, UserServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AppAuthService } from '../../../common/auth/app-auth.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { UserMenuComponent } from '../user-menu.component';
import { AvatarCollectionService } from '@shared/common/avatarView/avatar-collection.services';
import { NgForm } from '@angular/forms';
import { BreadcrumbItem } from '../../../common/sub-header/sub-header.component';
import { HeaderTitle } from '../../../common/header-title/header-title.model';
import { HeaderTitleService } from '../../../common/header-title/header-title.service';
import { MessageService } from 'abp-ng2-module';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { AppConsts } from '@shared/AppConsts';
import { isProfileImageDataUrl, normalizeProfileImageUrl, resolveProfileImageUrl } from '@shared/utils/profile-image.util';
import { Drawer } from 'primeng/drawer';

@Component({
    standalone: false,
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class MyProfileComponent extends AppComponentBase implements OnInit, OnDestroy {
    @ViewChild('myProfileForm', { static: true }) myProfileForm: NgForm;
    @ViewChild('topBarComponentData', { static: true }) topBarComponentData: UserMenuComponent;
    @ViewChild('photoDrawer') photoDrawer: Drawer;
    @Output() emitFunctionOfParent: EventEmitter<any> = new EventEmitter<any>();
    showEmail: boolean;
    showModal: boolean;
    currentPassword: string;
    newPassword: string;
    imagePathModal = '';
    confirmPassword: string;
    newEmail: string;
    confirmEmail: string="";
    fileExtension: any;
    imagePath = '';
    logoInput: any;
    pictureImage: any;
    fieldTextType: boolean;
    fieldTextTypeNewPassword: boolean;
    fieldTextTypeNewPasswordConfirm: boolean;

    passwordComplexitySetting: PasswordComplexitySetting = new PasswordComplexitySetting();
    checkEmail: boolean;
    myProfileData: MyProfileOutput = new MyProfileOutput();
    encryptPassword: any;
    decPassword: any;
    imageBase64: string;
    selectedAvatarIndex: number;
    isLoading: boolean;
    isFileLoading: boolean = false;
    hide = true;
    clicked = false;
    showPassword = false;
    emailshowModal = false;
    showImgModal = false;
    showImg = true;
    saving = false;
    icon = false;
    tabIndex = 1;
    allowedPhotoFile = ["png", "jpg", "jpeg"];
    isemailValid = false;
    isemailValidationerror = false;
    emailValidator: boolean;
    isEmailNotsame = false;
    iscurrentPassword = false;

    matchPassword: boolean;

    EmailCheck = false;
    isSocialLogincheck: boolean = true;

    newEmailId: string = "";
    photoImage = [{ 'id': 1, 'icon': '' }];
    isSocial: boolean = false;
    isSocialNumber = 0;

    socialId: number;
    myEmail: any;
    isImage = false;
    isImagepanel = true;
    isSidebarOpen: boolean = false;

    constructor(injector: Injector,
        private _router: Router,
        private toastr: ToastrService,
        private _appAuthService: AppAuthService,
        private _profileService: ProfileServiceProxy,
        private headerTitleService: HeaderTitleService,
        private _blobHelperServiceProxy: BlobHelperServiceProxy,
        private _messageService: MessageService,
        private _avatarCollectionService: AvatarCollectionService,
        private _userServiceProxy: UserServiceProxy,
        private _cdr: ChangeDetectorRef
           ) {
        super(injector);
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.spinnerService.show();
        this.SocialLoginVerify();
        this.photoImage = this._avatarCollectionService.getAllAvatars();

        const cachedProfileData = this.getCachedProfileData();
        if (cachedProfileData) {
            this.applyMyProfileData(cachedProfileData);
            this.completeInitialLoad();
        } else {
            this._profileService.myProfileInfo()
                .pipe(finalize(() => this.completeInitialLoad()))
                .subscribe(result => {
                    AppConsts.myProfileInfo = result;
                    localStorage.setItem('MyProfileData', JSON.stringify(result));
                    this.applyMyProfileData(result);
                });
        }

        this.getPasswordComplexitySetting();

        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem(this.l('Home')),
            new BreadcrumbItem(this.l('MyProfile'))
        ]));

    }

    private getCachedProfileData(): MyProfileOutput | null {
        if (AppConsts.myProfileInfo) {
            return AppConsts.myProfileInfo;
        }

        const loggedUserData = localStorage.getItem('MyProfileData');
        if (!loggedUserData) {
            return null;
        }

        try {
            return JSON.parse(loggedUserData);
        } catch {
            return null;
        }
    }

    private applyMyProfileData(userDetails: MyProfileOutput): void {
        this.myProfileData = userDetails ? Object.assign(new MyProfileOutput(), userDetails) : new MyProfileOutput();
        this.myEmail = this.myProfileData.emailAddress;
        this.imagePath = normalizeProfileImageUrl(this.myProfileData.imagePath);

        if (this.myProfileData.fullName) {
            const splitted = this.myProfileData.fullName.split(' ');
            this.myProfileData.firstName = splitted[0];
            this.myProfileData.lastName = splitted.slice(1).join(' ');
        }
    }

    private completeInitialLoad(): void {
        this.isLoading = false;
        this.spinnerService.hide();
    }

    SocialLoginVerify() {
        this._userServiceProxy.isCheckUserSocialLoginForWeb(abp.session.tenantId ? abp.session.tenantId: undefined, abp.session.userId).subscribe(res => {
        this.isSocialNumber = res;
            if (this.isSocialNumber == 1) {
                this.isSocial = true;
            }
            else if (this.isSocialNumber == 2) {
                this.isSocial = false;

            }
            else if (this.isSocialNumber == 3) {
                this.isSocial = false;
            }

            else {
                this.isSocial = true;
            }
        })

    }

    ngOnDestroy(): void {
        this.closePhotoDrawer();
    }

    private syncPublishedProfile(): void {
        const resolvedPath = resolveProfileImageUrl(this.myProfileData?.imagePath);
        this.imagePath = resolvedPath;

        AppConsts.myProfileInfo = this.myProfileData;
        AppConsts.loggedInUserImage = resolvedPath;
        localStorage.setItem('MyProfileData', JSON.stringify(this.myProfileData));
        localStorage.setItem('MyProfileDetails', JSON.stringify(this.myProfileData));
        localStorage.setItem('MyProfileDataSaved', 'true');

        if (resolvedPath) {
            localStorage.setItem('imagePath', resolvedPath);
        } else {
            localStorage.removeItem('imagePath');
        }

        abp.event.trigger('profilePictureChanged', resolvedPath);
    }

    private resolveImagePathForSave(): Promise<string> {
        if (!this.imagePath) {
            return Promise.resolve('');
        }

        if (!isProfileImageDataUrl(this.imagePath)) {
            return Promise.resolve(normalizeProfileImageUrl(this.imagePath));
        }

        const blobImgDto = new StoreImageOnBlobDto();
        blobImgDto.tenantId = this.appSession.tenant.id;
        blobImgDto.imgBase64String = this.imagePath.split(',')[1] ?? null;

        return firstValueFrom(this._blobHelperServiceProxy.getUrlAfterImageBlobStorage(blobImgDto)).then(
            imgLink => resolveProfileImageUrl(imgLink, this.imagePath)
        );
    }

    private persistMyProfile(isPasswordValid: number, isEmailValid: number): void {
        this._profileService.editMyProfile(this.myProfileData).pipe(finalize(() => { this.saving = false; })).subscribe(() => {
            if (isPasswordValid === 2 && isEmailValid === 2) {
                this.toastr.info(this.l('Changes updated successfully'));
            }
            if (isPasswordValid === 1) {
                const input = new ChangePasswordInput();
                input.currentPassword = this.currentPassword;
                input.newPassword = this.newPassword;
                this._profileService.changePasswordWithStatus(input)
                    .pipe(finalize(() => { this.saving = false; }))
                    .subscribe(result => {
                        if (result) {
                            this.toastr.info(this.l('Changes updated successfully'));
                            this.isLoading = false;
                            this.spinnerService.hide();
                            this.syncPublishedProfile();
                            this.close();
                            this.clearFormData();
                            this.stopFormProcess();
                        } else {
                            this.isLoading = false;
                            this.incorrectCurrentPassword = true;
                            this.spinnerService.hide();
                        }
                    });
            } else {
                this.isLoading = false;
                this.spinnerService.hide();
                this.syncPublishedProfile();
                this.close();
            }
        });
    }

    close(): void {
        this.closePhotoDrawer();
        this.isLoading = false;
        this.spinnerService.hide();
        void this._router.navigateByUrl(AppRoutes.dashboard);
    }

    onPhotoDrawerHide(): void {
        this.isSidebarOpen = false;
        this.clearStaleOverlays();
    }

    private closePhotoDrawer(): void {
        // Call hide() while the drawer is still open. PrimeNG 21's visible setter
        // does not disable modality on a programmatic false, so only hide()
        // removes the mask and scroll lock.
        if (this.photoDrawer) {
            try {
                this.photoDrawer.hide(false);
            } catch {
                // Drawer may already be torn down during destroy.
            }
        }

        this.isSidebarOpen = false;
        this.clearStaleOverlays();
    }

    private clearStaleOverlays(): void {
        const releaseScrollLock = () => {
            if (this.isSidebarOpen) {
                return;
            }

            const html = document.documentElement;
            const body = document.body;

            html.classList.remove('p-overflow-hidden');
            body.classList.remove('p-overflow-hidden', 'sidebar-open', 'modal-open');
            html.style.removeProperty('overflow');
            html.style.removeProperty('overflow-y');
            html.style.removeProperty('--p-scrollbar-width');
            body.style.removeProperty('overflow');
            body.style.removeProperty('overflow-y');
            body.style.removeProperty('padding-right');
            body.style.removeProperty('--p-scrollbar-width');

            document.querySelectorAll<HTMLElement>('.app-content-shell').forEach((shell) => {
                shell.style.removeProperty('overflow');
                shell.style.removeProperty('overflow-y');
            });

            document.querySelectorAll('.p-drawer-mask, .p-sidebar-mask, .p-component-overlay, .p-overlay-mask')
                .forEach((mask) => mask.remove());
        };

        releaseScrollLock();
        setTimeout(releaseScrollLock, 0);
        setTimeout(releaseScrollLock, 300);
    }

    async checkEmailIsValid(): Promise<number> {
        if (typeof this.newEmail !== 'undefined' && this.newEmail) {
            if (this.confirmEmail === this.newEmail) {
                const res = await firstValueFrom(this._profileService.checkEmail(this.newEmail));
                if (res === true) {
                    this.message.warn(this.l('EmailAddressAlreadyExists'));
                    return 0;
                } else {
                    return 1;
                }
            }
            return 0;
         }
         return 2;
    }

    checkPasswordIsValid(): number {
        if (typeof this.newPassword !== 'undefined' && this.newPassword) {
            if (this.confirmPassword === this.newPassword) {
                return 1;
            }
            return 0;
         }
         return 2;
    }

    clearFormData() {
        this.newEmail = '';
        this.confirmEmail = '';
        this.showEmail = false;
        this.showPassword = false;
        this.newPassword = '';
        this.confirmPassword = '';
        this.currentPassword = '';
    }

    datadisplay() {
        this.newEmailId = '';
        this.confirmEmail = '';
        this.EmailCheck = false;
        this.isEmailNotsame = false;
        this.emailValidError = false;
        this.iscurrentPassword = false;
    }

    stopFormProcess() {
        this.saving = false;
        this.clicked = false;
        this.isLoading = false;
        this.spinnerService.hide();
    }
    EmailValid(){
        this.emailValidError=false;
    }
    emailValidError= false;
    incorrectCurrentPassword:boolean = false;
    async save() {
        
        let result = this.newPassword.localeCompare(this.confirmPassword);
        if(result == 0){
            this.matchPassword = true;
        }else{
            this.matchPassword = false;
        }
        if(this.myProfileForm.invalid){
            
            return;
        }

        this.isLoading = true;
        this.spinnerService.show();
        this.saving = true;
        this.clicked = true;
        if (this.myProfileData.firstName == null) { this.myProfileData.firstName = ''; }
        if (this.myProfileData.lastName == null) { this.myProfileData.lastName = ''; }
        this.myProfileData.fullName = this.myProfileData.firstName + ' ' + this.myProfileData.lastName;
        if (this.imageBase64 !== undefined) {
            this.imagePath = this.imageBase64;
        }

        let isEmailValid = await this.checkEmailIsValid();
        let isPasswordValid = this.checkPasswordIsValid();
        if (isEmailValid === 0) { this.stopFormProcess(); return; }
        if (isPasswordValid === 0) { this.stopFormProcess(); return; }

        if (this.confirmEmail.length > 0) {
            this.myProfileData.emailAddress = this.confirmEmail;
        }

        this.resolveImagePathForSave().then(resolvedImageUrl => {
            this.myProfileData.imagePath = resolvedImageUrl || AppConsts.BackgroundImagephoto;
            this.persistMyProfile(isPasswordValid, isEmailValid);
        }).catch(() => {
            this.stopFormProcess();
            this._messageService.error(this.l('ErrorreadingFile'));
        });

    }

    cancel() {
        this.clearFormData();
        this.stopFormProcess();
    }

    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }

    toggleFieldTextTypeNewPassword() {
        this.fieldTextTypeNewPassword = !this.fieldTextTypeNewPassword;
    }

    toggleFieldTextTypeNewPasswordConfirm() {
        this.fieldTextTypeNewPasswordConfirm = !this.fieldTextTypeNewPasswordConfirm;

    }

    public async getfileContent(fileList: FileList) {
        if (!fileList || fileList.length === 0) {
            return;
        }

        const file = fileList[0];
        const fileName = file.name;
        this.fileExtension = fileName.replace(/^.*\./, '');

        if (!this.allowedPhotoFile.includes(this.fileExtension.toLocaleLowerCase())) {
            this._messageService.error(this.l("Pleaseselectpngjpgorjpegformattouploadimage"));
            return;
        }

        this.isFileLoading = true;
        this.isImage = true;
        this.isImagepanel = false;
        this._cdr.markForCheck();

        try {
            this.imagePathModal = await this.readFileAsDataURL(file);
            this.showImg = true;
            this.showImgModal = true;
            this.isFileLoading = false;
        } catch (error) {
            console.error('Error reading file:', error);
            this._messageService.error(this.l("ErrorreadingFile"));
            this.isFileLoading = false;
        }

        this._cdr.markForCheck();
    }

    private readFileAsDataURL(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                resolve(e.target.result);
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    }

    cancelPhoto() {
        this.showImgModal = false;
        this.imagePathModal = '';
        this.selectedAvatarIndex = -1;
        this.closePhotoDrawer();
    }

    deletePicture() {
        this.selectedAvatarIndex = -1;
        this.imagePath = "";
        this.imagePathModal = "";
     
        this.isImage = true;
        this.closePhotoDrawer();
    }

    savePhoto() {
  
        this.imagePath = this.imagePathModal;
        this.isImagepanel=true;
        this.isImage = true;
        this.showImgModal = false;
        this.closePhotoDrawer();
    }

    selectIcon(imgPath: string, index: number) {
        this.selectedAvatarIndex = index;
        this.isImage = true;
        this.imagePathModal = imgPath;
        this.imageBase64 = this.getBase64Image(document.getElementById('Img' + index));
        this.imagePathModal = this.imageBase64;
    }

    changeProfilePicture(): void {
        abp.event.trigger('app.show.changeProfilePictureModal');
    }

    getPasswordComplexitySetting() {
        this.currentPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this._profileService.getPasswordComplexitySetting().subscribe(result => {
            this.passwordComplexitySetting = result.setting;
        });
    }

    onKey(tabIndex1): void {
        if (tabIndex1 === 1) {
            this.tabIndex = 1;
        } else if (tabIndex1 === 2) {
            this.tabIndex = 2;
        }
    }

    checkPassword(event) {
        const password = this.newPassword;
        const confirm_new_password = event.target.value;

        if (password !== undefined) {
            if (confirm_new_password !== password) {
                this.checkEmail = true;
            } else {
                this.checkEmail = false;
            }
        }
    }

    getBase64Image(img) {
        let canvas = document.createElement('canvas');
        canvas.width = img.width * 2;
        canvas.height = img.height * 2;
        let context = canvas.getContext('2d');
        context.drawImage(img, 0, 0, canvas.width, canvas.height);
        let dataURL = canvas.toDataURL('image/png', 1);
        return dataURL;
    }

    removeImage() {
        this.isImagepanel=true;
        this.showImgModal = false;
        this.deletePicture();
    }
    showSideBar() {
        this.isSidebarOpen = true;
    }

    logOutDevices() {
        this._appAuthService.logout();
    }

    currentPasswordChanged(){
        this.incorrectCurrentPassword = false;
    }
}
